<template>
  <div class="corpo-info-view">
    <div class="corpo-info-header">
      <h-btn @click="backHome" color="text-primary" text class="back-btn">
        <v-icon>mdi-menu-left</v-icon>
        {{ $t('components.home_gift_cards_view.back_btn') }}
      </h-btn>

      <h1 class="title-header">{{ $t('components.corpo_info_view.title') }}</h1>
    </div>

    <div class="hero-section">
      <div class="hero-background" :style="`background-image: url(${$urlProvider.GenerateHelloCorpoImageUrl(corpoImageBackground)})`"></div>

      <div class="hero-content">
        <div class="hero-content-box">
          <h2 class="hero-title">
            {{ $t('components.corpo_info_view.hero_title_1') }}
            <span class="playfair-text">{{ $t('components.corpo_info_view.hero_title_2') }}</span>
            {{ $t('components.corpo_info_view.hero_title_3') }}
          </h2>

          <p class="hero-text">
            {{ $t('components.corpo_info_view.hero_text') }}
          </p>

          <div class="hero-call-to-action">
            <h-btn class="cta-btn" block color="secondary" to="cards" x-large rounded>{{ $t('components.corpo_info_view.hero_explore_cta') }}</h-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="why-corpo-section">
      <div class="image-container">
        <img class="image" :alt="$t('components.corpo_info_view.why_corpo_alt')" :src="$urlProvider.GenerateHelloCorpoImageUrl('hello_corpo_team_bonding_v1.png')" />
      </div>
      <div class="text">
        <h3 class="section-title">{{ $t('components.corpo_info_view.why_corpo_title') }}</h3>

        <ul>
          <li>
            <h4>{{ $t('components.corpo_info_view.why_corpo_list.title_1') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.why_corpo_list.text_1') }}</p>
          </li>

          <li>
            <h4>{{ $t('components.corpo_info_view.why_corpo_list.title_2') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.why_corpo_list.text_2') }}</p>
          </li>

          <li>
            <h4>{{ $t('components.corpo_info_view.why_corpo_list.title_3') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.why_corpo_list.text_3') }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="ideal-for-section">
      <div class="content">
        <div class="text">
          <div class="text-container">
            <h3 class="section-title">{{ $t('components.corpo_info_view.ideal_for_title') }}</h3>

            <ul>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_1') }}</h4>
              </li>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_2') }}</h4>
              </li>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_3') }}</h4>
              </li>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_4') }}</h4>
              </li>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_5') }}</h4>
              </li>
              <li>
                <h4>{{ $t('components.corpo_info_view.ideal_for_list.text_6') }}</h4>
              </li>
            </ul>
          </div>
        </div>

        <div class="image-container">
          <img class="image" :alt="$t('components.corpo_info_view.ideal_for_alt')" :src="$urlProvider.GenerateHelloCorpoImageUrl(corpoCustomizableSrc)" />
        </div>
      </div>
    </div>

    <div class="fiscal-section">
      <div class="text">
        <h3 class="section-title">{{ $t('components.corpo_info_view.fiscal_title') }}</h3>

        <ul>
          <li>
            <h4>{{ $t('components.corpo_info_view.fiscal_list.title_1') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.fiscal_list.text_1') }}</p>
          </li>
          <li>
            <h4>{{ $t('components.corpo_info_view.fiscal_list.title_2') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.fiscal_list.text_2') }}</p>
          </li>
          <li>
            <h4>{{ $t('components.corpo_info_view.fiscal_list.title_3') }}</h4>
            <p class="h-text-1">{{ $t('components.corpo_info_view.fiscal_list.text_3') }}</p>
          </li>
        </ul>
      </div>

      <div class="image-container">
        <img class="image" :alt="$t('components.corpo_info_view.fiscal_alt')" :src="$urlProvider.GenerateHelloCorpoImageUrl('hello_corpo_fiscal_advantages_v1.png')" />
      </div>
    </div>

    <div class="simple-corpo">
      <div class="content">
        <div class="text">
          <h2 class="hero-title">
            {{ $t('components.corpo_info_view.simple_title_1') }}&nbsp;<span class="playfair-text">{{ $t('components.corpo_info_view.simple_title_2') }}</span>
          </h2>

          <p class="hero-text">
            {{ $t('components.corpo_info_view.simple_text_1') }} <strong>{{ $t('components.corpo_info_view.simple_text_2') }}</strong> {{ $t('components.corpo_info_view.simple_text_3') }}
          </p>
        </div>

        <div class="image-container desktop">
          <img class="image" :alt="$t('components.corpo_info_view.simple_alt')" :src="$urlProvider.GenerateHelloCorpoImageUrl(corpoSimpleDesktopSrc)" />
        </div>

        <div class="image-container mobile">
          <img class="image" :alt="$t('components.corpo_info_view.simple_alt')" :src="$urlProvider.GenerateHelloCorpoImageUrl(corpoSimpleMobileSrc)" />
        </div>

        <div class="cta">
          <h-btn class="cta-btn" block color="secondary" to="cards" large rounded>{{ $t('components.corpo_info_view.simple_explore_cta') }}</h-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  title: (args) => args.$t('page_title.corpo_info'),
  data() {
    return {
      width: window.innerWidth,
    };
  },
  watch: {
    currentLocale() {
      this.$title = this.$t('page_title.corpo_info');
    },
  },
  computed: {
    ...mapGetters('ui', ['currentLocale']),
    corpoImageBackground() {
      if (this.width > 960) {
        return 'hello_corpo_info_banner_v1.jpg';
      }
      return 'hello_corpo_info_banner_v1.jpg?tr=w-0.5';
    },
    corpoCustomizableSrc() {
      return this.currentLocale === 'fr' ? 'hello_corpo_customizable_fr_v1.png' : 'hello_corpo_customizable_en_v1.png';
    },
    corpoSimpleDesktopSrc() {
      return this.currentLocale === 'fr' ? 'hello_corpo_simple_desktop_fr_v1.png' : 'hello_corpo_simple_desktop_en_v1.png';
    },
    corpoSimpleMobileSrc() {
      return this.currentLocale === 'fr' ? 'hello_corpo_simple_mobile_fr_v1.png' : 'hello_corpo_simple_mobile_en_v1.png';
    },
  },
  methods: {
    backHome() {
      this.$router.pushNoDuplicate({ name: 'home' });
    },
  },
};
</script>

<style lang="scss" scoped>
.corpo-info-header {
  max-width: var(--page-content-max-width);
  margin: 0 auto;
  padding-left: var(--hc-page-margin);
  padding-right: var(--hc-page-margin);

  padding-top: var(--gap);
  padding-bottom: var(--gap);

  @media ($sm-min) {
    padding-bottom: var(--gap-xxlarge);
    padding-top: var(--gap-xxlarge);
  }
}

.back-btn {
  padding-bottom: 48px;
  font-size: 16px;
}

.title-header {
  font-size: 40px;
  font-weight: 400;
  font-family: 'Apfel Grotezk';

  padding-top: var(--gap-large);

  @media ($sm-min) {
    font-size: 50px;
    padding-top: var(--gap-xxlarge);
  }

  @media ($lg-min) {
    font-size: 70px;
    padding-top: var(--gap-xxlarge);
  }
}

.corpo-info-view {
  --color-text: #000;
  --color-grey-3: #737373;
  color: var(--color-text);

  --hc-page-margin: 24px;
  --hc-vertical-margin-separator: 36px;

  @media ($md-min) {
    --hc-page-margin: 36px;
    --hc-vertical-margin-separator: 60px;
  }
  @media ($lg-min) {
    --hc-page-margin: 48px;
    --hc-vertical-margin-separator: 112px;
  }
}

.hero-title {
  color: black;
  font-family: 'Apfel Grotezk';
  font-style: normal;
  font-weight: 400;
  line-height: 1.1;

  font-size: 36px;

  margin-bottom: 24px;
  text-align: left;

  .playfair-text {
    font-family: 'Playfair Display';
    font-size: 36px;
    font-weight: 500;
    line-height: 1.1;
  }

  @media ($md-min) {
    font-size: 45px;

    .playfair-text {
      font-size: 45px;
    }
  }

  @media ($lg-min) {
    font-size: 60px;

    .playfair-text {
      font-size: 60px;
    }
  }
}

.hero-text {
  color: black;

  margin-bottom: 48px;
  text-align: left;
  font-style: normal;
  font-weight: 500;

  font-size: 18px;

  @media ($sm-min) {
    font-size: 24px;
  }
  @media ($lg-min) {
    font-size: 30px;
  }
}

.hero-call-to-action {
  padding: 0;

  @media ($lg-min) {
    text-align: left;
    max-width: 400px;
  }

  .cta-btn {
    border-radius: 50px;
    height: 48px;
    font-size: 16px;

    @media ($md-min) {
      height: 60px;
      font-size: 20px;
    }
  }
}

.hero-section {
  position: relative;
  overflow: hidden;

  display: grid;

  grid-template-rows: 1fr min-content;

  width: 100%;

  margin-bottom: var(--hc-vertical-margin-separator);

  .hero-content-box {
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.4);
    padding: var(--gap-xxlarge);

    padding-bottom: var(--hc-vertical-margin-separator);

    backdrop-filter: blur(54px);
    -webkit-backdrop-filter: blur(54px);

    width: 100%;

    @media ($sm-min) {
      padding: 24px;

      margin-bottom: 60px;
      margin-top: 60px;
      margin-left: var(--hc-page-margin);
      max-width: 500px;
    }

    @media ($lg-min) {
      padding: 40px;
      margin-bottom: 136px;
      margin-top: 136px;

      display: flex;

      flex-direction: column;
      max-width: 767px;
    }
  }

  .hero-content {
    max-width: var(--page-content-max-width);
    width: 100%;

    margin: 0 auto;
  }

  .hero-background {
    min-width: 100%;

    background-repeat: no-repeat;

    aspect-ratio: 360 / 240;

    background-size: 100% 100%;

    @media ($sm-min) {
      height: 200%;
      aspect-ratio: unset;
      background-size: 120% auto;

      background-position-y: bottom;
      background-position-x: right;

      position: absolute;
      bottom: 0;
      right: 0;
    }

    @media ($md-min) {
      background-size: 100% auto;
    }
  }
}

.text {
  flex-grow: 1;

  li::before {
    content: '\F05E1';
    font: normal normal normal 24px / 1 'Material Design Icons';
    padding-top: 0px;
    position: absolute; /* Position the icon */
    left: calc(calc(var(--gap-small) + 12px) * -1); /* Align to the left of the list item */
    top: calc(var(--font-size-h4) * 1.3 / 2 - 12px); /* Adjust vertical alignment (similar to your padding-top) */
  }

  li:last-child {
    padding-bottom: 0;
  }

  li {
    position: relative;
    list-style: none;
    padding-left: var(--gap-small);
    padding-bottom: 24px;

    h4:not(:last-child) {
      padding-bottom: 6px;
    }

    p {
      color: var(--color-grey-3);
    }
  }

  .section-title {
    font-size: 36px;
    font-family: 'Apfel Grotezk';
    line-height: 130%;

    font-weight: 500;

    text-align: center;

    padding-bottom: 24px;

    padding-left: var(--gap-small);
    padding-right: var(--gap-small);

    @media ($sm-min) {
      padding-left: 0;
      padding-right: 0;
    }

    @media ($md-min) {
      font-size: 38px;
      text-align: left;
    }

    @media ($lg-min) {
      font-size: 48px;
    }
  }
}

.why-corpo-section {
  padding-left: var(--hc-page-margin);
  padding-right: var(--hc-page-margin);
  padding-bottom: var(--hc-vertical-margin-separator);

  width: 100%;

  @media ($md-min) {
    margin: auto;
    max-width: var(--page-content-max-width);

    display: flex;

    align-items: center;

    gap: 36px;
  }

  @media ($lg-min) {
    gap: 100px;
  }

  .text {
    max-width: 600px;
    margin: auto;

    @media ($md-min) {
      width: 475px;

      max-width: unset;
      margin: unset;

      flex-shrink: 0;
    }

    @media ($lg-min) {
      width: 600px;
    }
  }

  .image-container {
    padding-bottom: 36px;

    width: 100%;

    @media ($md-min) {
      padding-bottom: unset;
      align-self: self-start;
    }

    @media ($lg-min) {
      align-self: center;
    }

    .image {
      width: 100%;
    }
  }
}

.ideal-for-section {
  background-color: rgba(224, 229, 244, 1);
  overflow: hidden;

  margin-bottom: var(--hc-vertical-margin-separator);

  @media ($md-min) {
    width: 100%;
  }

  .content {
    max-width: 460px;

    padding-left: var(--hc-page-margin);
    padding-right: var(--hc-page-margin);

    margin: auto;

    margin-bottom: -36px;

    padding-top: 36px;

    @media ($md-min) {
      margin-top: 0;
      margin-bottom: unset;
      position: unset;
      height: unset;

      max-width: var(--page-content-max-width);
      display: flex;
      align-items: center;
      padding-top: var(--hc-vertical-margin-separator);
      padding-bottom: var(--hc-vertical-margin-separator);
    }

    @media ($lg-min) {
      margin-bottom: unset;
      gap: 100px;
      align-items: unset;
    }
  }

  .text {
    padding-bottom: var(--hc-vertical-margin-separator);

    @media ($md-min) {
      align-self: center;
      justify-self: center;
      padding-bottom: unset;
      min-width: 450px;
    }

    @media ($lg-min) {
      min-width: unset;
      display: flex;
      flex-shrink: 0;
      justify-content: center;
    }
  }

  .image-container {
    text-align: center;

    @media ($md-min) {
      position: unset;
      width: 600px;
    }

    @media ($lg-min) {
      position: relative;
      width: 750px;
      height: 10px;
      top: 45px;
    }

    .image {
      width: 100%;
      border-radius: 12px;
      box-shadow: 0px 1.649px 61.855px 0px rgba(46, 49, 145, 0.12);

      @media ($sm-min) {
        margin-bottom: unset;
        margin-top: unset;

        position: relative;
      }

      @media ($md-min) {
        border-radius: 20px;
      }
    }
  }
}

.fiscal-section {
  padding-left: var(--hc-page-margin);
  padding-right: var(--hc-page-margin);
  padding-bottom: var(--hc-vertical-margin-separator);

  width: 100%;

  @media ($md-min) {
    margin: auto;
    max-width: var(--page-content-max-width);

    display: flex;
    flex-direction: row-reverse;

    align-items: center;

    gap: 36px;
  }

  @media ($lg-min) {
    gap: 100px;
  }

  .text {
    padding-bottom: 36px;

    max-width: 600px;
    margin: auto;

    @media ($md-min) {
      padding-bottom: unset;
      width: 475px;

      max-width: unset;
      margin: unset;

      flex-shrink: 0;
    }

    @media ($lg-min) {
      width: 600px;
    }
  }

  .image-container {
    width: 100%;

    @media ($md-min) {
      padding-bottom: unset;
      align-self: self-start;
    }

    @media ($lg-min) {
      align-self: center;
    }

    .image {
      width: 100%;

      @media ($md-min) {
        position: relative;
        left: -3%;
      }
    }
  }
}

.simple-corpo {
  background-color: rgba(224, 229, 244, 1);

  @media ($sm-min) {
    overflow: hidden;
    width: 100%;
  }

  .content {
    padding-top: var(--hc-vertical-margin-separator);
    padding-bottom: var(--hc-vertical-margin-separator);

    padding-left: var(--hc-page-margin);
    padding-right: var(--hc-page-margin);

    gap: 100px;

    @media ($sm-min) {
      margin: auto;
      max-width: 700px;
      width: 100%;
    }

    @media ($lg-min) {
      max-width: var(--page-content-max-width);

      display: grid;

      grid-template-columns: 1fr auto;
      grid-template-rows: auto auto;
      grid-row-gap: 0;

      align-items: center;
    }
  }

  .text {
    padding-bottom: 36px;

    @media ($sm-min) {
      padding-bottom: 48px;
    }

    @media ($lg-min) {
      padding-bottom: 0;
      grid-column-start: 1;
      grid-column-end: 2;

      grid-row-start: 1;
      grid-row-end: 1;
    }

    .hero-title {
      text-align: center;

      margin-bottom: 24px;

      @media ($lg-min) {
        text-align: left;
      }
    }

    .hero-text {
      text-align: left;
      @media ($sm-min) {
        text-align: center;
      }
      @media ($lg-min) {
        text-align: left;
      }
    }
  }

  .cta {
    .cta-btn {
      border-radius: 50px;
      height: 48px;
      font-size: 16px;

      @media ($md-min) {
        height: 60px;
        font-size: 20px;
      }
    }

    width: 100%;
    max-width: 450px;
    margin: auto;

    @media ($lg-min) {
      grid-column-start: 1;
      grid-column-end: 2;

      grid-row-start: 2;
      grid-row-end: 3;
      margin: unset;

      padding-top: var(--gap);
    }
  }

  .image-container {
    margin: auto;

    padding-bottom: 36px;

    @media ($md-min) {
      flex-shrink: 0;
      width: 450px;
    }

    @media ($lg-min) {
      width: 720px;
      padding-bottom: 0;
      grid-column-start: 2;
      grid-column-end: 3;

      grid-row-start: 1;
      grid-row-end: 3;
    }

    .image {
      width: 100%;
    }
  }
}

.desktop {
  display: none;
  @media ($sm-min) {
    display: block;
  }
}

.mobile {
  @media ($sm-min) {
    display: none;
  }
}
</style>
